import { render, staticRenderFns } from "./DetailRoutinePrint.vue?vue&type=template&id=d5d652b6"
import script from "./DetailRoutinePrint.vue?vue&type=script&lang=js"
export * from "./DetailRoutinePrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports